import { PagesModule } from 'pages/pages.module';
import { NgModule } from '@angular/core';
import { ComponentsModule } from 'components/components.module';
import { AdminExerciseSlotListPage } from 'pages/admin-exercise-slot-list/admin-exercise-slot-list';

@NgModule({
    declarations: [AdminExerciseSlotListPage],
    imports: [PagesModule, ComponentsModule],
    exports: [AdminExerciseSlotListPage]
})
export class AdminExerciseSlotListPageModule {}
